import React from 'react';
import PropTypes from 'prop-types';
import ReactEcharts from 'echarts-for-react';
import merge from 'lodash.merge';

import Wrapper from 'src/Wrapper';
import { stylePropType } from 'src/PropTypes';
import { Style1 } from 'src/styles';

const Copy = {
  xAxis: ['Decile (Lowest to Highest Probability of Engagement)'],
  yAxis: ['Lift', 'Engaged Persons as Percentage of Decile'],
};

function Lift({ title, labels, liftSeries, engagementSeries, maxEngagement, maxLift, style, options, copyOverride }) {
  const mergedCopy = merge(Copy, copyOverride);
  const engagementBarSeriesData = [];
  for (let i = 0; i < engagementSeries.values.length; i += 1) {
    const engaged = engagementSeries.values[i];
    engagementBarSeriesData.push({
      value: engaged.toFixed(2),
    });
  }
  const chartOption = {
    title: {
      ...style.global.title,
      text: title,
    },
    toolbox: {
      ...style.global.toolbox,
    },
    textStyle: {
      ...style.Lift.textStyle,
    },
    label: {
      ...style.Lift.label,
    },
    backgroundColor: style.global.backgroundColor,
    tooltip: {
      ...style.Lift.tooltip,
      show: true,
    },
    grid: {
      ...style.Lift.grid,
    },
    legend: {
      show: true,
    },
    xAxis: {
      ...style.Lift.xAxis,
      data: labels.values.map((value) => value.toFixed(0)),
      axisPointer: {
        label: {
          formatter: (params) => `${params.value - 100 / labels.values.length} - ${params.value} percentiles of users`,
        },
      },
    },
    yAxis: [
      {
        ...style.Lift.Line.yAxis,
        name: mergedCopy.yAxis[0],
        position: 'left',
        min: 0,
        max: maxLift,
      },
      {
        ...style.Lift.Bar.yAxis,
        name: mergedCopy.yAxis[1],
        position: 'right',
        min: 0,
        max: maxEngagement,
      },
    ],
    series: [
      {
        ...style.Lift.Bar.series,
        type: 'bar',
        name: '% of HIT persons',
        data: engagementBarSeriesData,
        yAxisIndex: 1,
      },
      {
        type: 'line',
        name: liftSeries.name,
        data: liftSeries.values.map((value) => value.toFixed(2)),
        markLine: {
          ...style.Lift.Line.markLine,
          data: [
            {
              yAxis: 1,
            },
          ],
        },
        lineStyle: {
          ...style.Lift.Line.lineStyle,
        },
        ...style.Lift.Line.series,
      },
    ],
  };
  const mergedOptions = merge(chartOption, options);
  return (
    <Wrapper>
      <ReactEcharts
        style={{
          width: '100%',
          height: '100%',
        }}
        option={mergedOptions}
        theme="pinpoint"
      />
    </Wrapper>
  );
}

Lift.propTypes = {
  title: PropTypes.string,
  labels: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  liftSeries: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  engagementSeries: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  maxEngagement: PropTypes.number.isRequired,
  maxLift: PropTypes.number.isRequired,
  style: stylePropType,
  options: PropTypes.shape({}),
  copy: PropTypes.shape({}),
};

Lift.defaultProps = {
  title: '',
  options: {},
  style: Style1,
  copy: {},
};

export default Lift;
